module.exports = __webpack_public_path__ + "assets/right-direction-arrow.6ced30a8.svg";